export type CanvasThemeMode = 'light' | 'dark';

export interface CanvasThemeTokenSet {
  primary: string;
  secondary: string;
  background: string;
  stageBackground: string;
  surface: string;
  surfaceMuted: string;
  border: string;
  text: string;
  muted: string;
  shadow: string;
}

export interface CanvasThemePackage {
  id: string;
  name: string;
  description: string;
  lightOverrides: Partial<CanvasThemeTokenSet>;
  darkOverrides: Partial<CanvasThemeTokenSet>;
}

export interface CanvasThemeFieldDefinition {
  key: keyof CanvasThemeTokenSet;
  label: string;
}

export const CANVAS_THEME_FIELDS: CanvasThemeFieldDefinition[] = [
  { key: 'primary', label: 'Primary' },
  { key: 'secondary', label: 'Secondary' },
  { key: 'background', label: 'Canvas background' },
  { key: 'stageBackground', label: 'Stage background' },
  { key: 'surface', label: 'Surface' },
  { key: 'surfaceMuted', label: 'Muted surface' },
  { key: 'border', label: 'Border' },
  { key: 'text', label: 'Text' },
  { key: 'muted', label: 'Muted text' },
  { key: 'shadow', label: 'Shadow' }
];

export const DEFAULT_CANVAS_THEME_LIGHT: CanvasThemeTokenSet = {
  primary: '#2563eb',
  secondary: '#7c3aed',
  background: '#ffffff',
  stageBackground: '#eef2f7',
  surface: '#ffffff',
  surfaceMuted: 'rgba(15, 23, 42, 0.06)',
  border: 'rgba(15, 23, 42, 0.08)',
  text: '#0f172a',
  muted: '#475569',
  shadow: '0 1.5rem 3rem rgba(15, 23, 42, 0.08)'
};

export const DEFAULT_CANVAS_THEME_DARK: CanvasThemeTokenSet = {
  primary: '#60a5fa',
  secondary: '#a78bfa',
  background: '#0f141b',
  stageBackground: '#151b24',
  surface: '#18202b',
  surfaceMuted: 'rgba(255, 255, 255, 0.06)',
  border: 'rgba(255, 255, 255, 0.12)',
  text: '#f3f6fb',
  muted: '#b8c2cf',
  shadow: '0 1.5rem 3rem rgba(0, 0, 0, 0.34)'
};

export const DEFAULT_CANVAS_THEME_PACKAGE: CanvasThemePackage = {
  id: 'default',
  name: 'Default',
  description: 'Uses the default builder preview colors.',
  lightOverrides: {},
  darkOverrides: {}
};

export const BUILT_IN_CANVAS_THEME_PACKAGES: CanvasThemePackage[] = [
  {
    id: 'abcd',
    name: 'Abcd',
    description: 'A bright experimental override package.',
    lightOverrides: {
      primary: '#41ff00',
      secondary: '#ff006e',
      background: '#ffffff',
      stageBackground: '#f5f7fa',
      surface: '#ffffff'
    },
    darkOverrides: {
      primary: '#8a00e8',
      secondary: '#ff0080',
      background: '#0a0e27',
      stageBackground: '#121832',
      surface: '#1a1f3a',
      muted: '#b8c2ff'
    }
  },
  {
    id: 'acme-corp',
    name: 'Acme Corp',
    description: 'Corporate blue/gold package derived from the app theme structure.',
    lightOverrides: {
      primary: '#0051ba',
      secondary: '#ffc72c',
      background: '#f8f9fa',
      stageBackground: '#edf2f7',
      surface: '#ffffff'
    },
    darkOverrides: {
      primary: '#4d94ff',
      secondary: '#ffd454',
      background: '#0f1419',
      stageBackground: '#151b22',
      surface: '#1a232c'
    }
  }
];
